import whitelabelConfig from "./whitelabel.config.js";

export default {
  install(Vue, _options) {
    Vue.whiteLabelConfig = whitelabelConfig[process.env.VUE_APP_BRAND];
    Vue.prototype.$whiteLabelConfig =
      whitelabelConfig[process.env.VUE_APP_BRAND];
  },
};
